import { listen, listenLanguageChange } from "./History.js";
import { getInstance, getScroll, getTranslator } from "/index.js";
import PageTransitioner from "@blocks/PageTransitioner";

export default class Router {
  constructor() {
    this.req = new XMLHttpRequest();
    this.currentRoute = window.location.pathname;
    this.currentHash = window.location.hash;
    this.pageTransitioner = new PageTransitioner(
      document.querySelector(".page-transitioner")
    );

    listen((source, destination) => {
      //window.App.setIsPageChanging(true);
      this.startLoad(source, destination);
    });

    listenLanguageChange(this.changeLanguage);

    window.addEventListener("popstate", this.onPopState);
  }

  changeLanguage = async () => {
    this.currentHash = window.location.hash;

    await this.pageTransitioner.show();

    // Hide Nav if visible
    if (document.body.classList.contains("nav-visible")) {
      const navInstance = getInstance(document.querySelector(".nav"));
      if (navInstance && navInstance.hide) {
        navInstance.changeState(false);
      }
    }

    // Tranlsate page
    await window.App.translate();

    // Reset the scroll
    const scroll = getScroll();
    if (scroll) {
      scroll.reset();
    }

    this.pageTransitioner.hide();
  };

  onPopState = () => {
    if (
      window.location.pathname === this.currentRoute &&
      window.location.hash !== this.currentHash
    ) {
      this.changeLanguage();
    } else {
      this.startLoad(
        this.currentRoute,
        window.location.pathname.replace(/\/$/, "")
      );
    }
  };

  startLoad = async (source, destination) => {
    const hashIndex = destination.indexOf("#");
    if (hashIndex > 0) {
      destination = destination.substring(0, hashIndex - 1);
    }

    /*    if (destination.length < 1) {
      window.location.reload();
      return;
    }
*/
    const navVisible = document.body.classList.contains("nav-visible");
    if (navVisible) {
      document.body.classList.add("no-transitions");
      this.getContentFrom(destination, source);
    } else {
      await this.pageTransitioner.show();
      this.getContentFrom(destination, source);
    }
  };

  getContentFrom(destination, source) {
    if (this.req != null) {
      this.req.open("GET", `${destination}/`, true);
      this.req.onreadystatechange = () => {
        this.newContentReceived(destination, source);
      };
      this.req.responseType = "document";

      this.req.send();
    } else {
    }
  }

  newContentReceived = async (destination, source) => {
    if (this.req.readyState == 4 && this.req.status == 200) {
      const receivedDocument = this.req.responseXML;

      // Update Page Title
      document.title = receivedDocument.title;

      // Update main classes
      const receivedMain = receivedDocument.querySelector("main");
      const main = document.querySelector("main");
      main.className = receivedMain.className;

      // Update main scroll attributes
      if (receivedMain.dataset.direction) {
        main.dataset.direction = receivedMain.dataset.direction;
      }

      if (receivedMain.dataset.scrollContainer) {
        main.dataset.scrollContainer = receivedMain.dataset.scrollContainer;
      }

      // Update main content
      main.innerHTML = receivedMain.innerHTML;

      // Reset main instance
      main.removeAttribute("data-instance-index");

      // Reset body instance
      document.body.removeAttribute("data-instance-index");

      // Add Header if missing
      const receivedDocumentHeader = receivedDocument.querySelector("header");
      if (!document.querySelector("header") && receivedDocumentHeader) {
        const header = receivedDocumentHeader.cloneNode(true);
        document.body.insertBefore(header, main);
      }

      // Init items
      await window.App.initItems();

      // Init clones
      await window.App.initClones();

      // Translate
      await window.App.translate();

      //window.App.initColors();

      // Update body classes
      const bodyClassList = [...document.body.classList];
      bodyClassList.forEach((item) => {
        if (
          item !== "page-loading" &&
          item !== "loaded" &&
          item !== "nav-visible"
        ) {
          document.body.classList.remove(item);
        }
      });

      receivedDocument.body.classList.forEach((item) => {
        document.body.classList.add(item);
      });

      const headerNode = document.querySelector("header");
      if (headerNode) {
        const header = getInstance(headerNode);
        //header.updateActiveNavLink();
      }

      // Hide Nav if visible
      if (document.body.classList.contains("nav-visible")) {
        const navInstance = getInstance(document.querySelector(".nav"));
        if (navInstance && navInstance.hide) {
          navInstance.changeState();
          //navInstance.updateActiveNavLink();
        }
      }

      const scroll = getScroll();
      if (scroll) {
        scroll.reset();
      }

      const hash = window.location.hash;
      if (hash.length > 0) {
        const section = document.querySelector(`${hash}`);
        if (section) {
          scroll.scrollTo(section);
        }
      }

      await this.pageTransitioner.hide();

      await window.App.onPageChangeComplete();
    }
  };
}
